import { useRef, useState } from "react";
import { FileUp, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const UploadZone = ({ testId, title, hint, accept, multiple = false, onFiles, busy, children }) => {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);

  const handle = (fileList) => {
    const files = Array.from(fileList || []);
    if (files.length) onFiles(files);
  };

  return (
    <div data-testid={testId}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files); }}
      onClick={() => !busy && inputRef.current?.click()}
      className={cn("cursor-pointer rounded-md border-2 border-dashed p-6 text-center transition-colors duration-200 sm:p-8",
        drag ? "border-blue-400 bg-slate-800/70" : "border-blue-500/40 bg-slate-900/50 hover:bg-slate-800/60", busy && "pointer-events-none opacity-70")}>
      <input ref={inputRef} type="file" className="hidden" accept={accept} multiple={multiple} data-testid={`${testId}-input`}
        onChange={(e) => { handle(e.target.files); e.target.value = ""; }} />
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-sm bg-blue-600/20 text-blue-300">
        {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : <FileUp className="h-6 w-6" />}
      </div>
      <div className="font-heading mt-4 text-xl font-bold uppercase tracking-tight">{title}</div>
      <div className="mt-1 text-sm text-slate-400">{hint}</div>
      {children}
    </div>
  );
};
